import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { nfn } from '../../common';
import Dropdown from '../Dropdown';
import OverlayMatch from './OverlayMatch';
import Icon from '../Icon';
import arrowIcon from '../CheckboxSelect/images/arrow-down.svg';
import deleteIcon from '../Input/images/clear.svg';

export default class InputMatch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible
    };
    this.hideDropdown = this.hideDropdown.bind(this);
    this.changeVisible = this.changeVisible.bind(this);
    this.renderOverlay = this.renderOverlay.bind(this);
    this.renderValue = this.renderValue.bind(this);
  }
  hideDropdown() {
    this.setState({
      visible: false
    });
  }
  changeVisible(visible) {
    if (visible !== this.state.visible) {
      this.setState({
        visible
      });
    }
  }

  renderOverlay({ name, type, value, typeOptions }) {
    const { placeholder } = this.props;
    return (
      <OverlayMatch
        ensureFn={this.props.onChange}
        placeholder={placeholder}
        typeOptions={typeOptions}
        name={name}
        type={type}
        value={value}
        hideDropdown={this.hideDropdown}
      />
    );
  }

  renderValue(value) {
    const { defaultValue } = this.props;
    if (value.length > 0) {
      if (value.length > 1) {
        return `${value[0]}等${value.length}个值`;
      }
      return value[0];
    }
    return defaultValue;
  }
  render() {
    const { visible } = this.state;
    const {
      className,
      name,
      type,
      title,
      value,
      onDelete,
      canDelete,
      typeOptions
    } = this.props;
    const classes = classNames('input-match-wrapper', className);
    return (
      <div className={classes}>
        <Dropdown
          overlay={this.renderOverlay({ name, type, value, typeOptions })}
          visible={visible}
          onVisibleChange={this.changeVisible}
          trigger="click"
          stopPropagation={false}
        >
          <div className="dropdown-value">
            <b>{title}:</b>
            <div className="input-val">{this.renderValue(value)}</div>
            <Icon link={arrowIcon} className="drop-down-icon " />
          </div>
        </Dropdown>
        {canDelete ? (
          <Icon
            link={deleteIcon}
            className="delete-icon"
            onClick={() => onDelete({ name })}
          />
        ) : null}
      </div>
    );
  }
}

InputMatch.propTypes = {
  /** 标题 */
  title: PropTypes.string,
  /** 字段名称 */
  name: PropTypes.string,
  /** 下拉是否可见 */
  visible: PropTypes.bool,
  /** 匹配类型*/
  type: PropTypes.oneOf(['exact', 'fuzzy']),
  /** 类型选项*/
  typeOptions: PropTypes.array,
  /** 数值 */
  value: PropTypes.array,
  /** 删除回调 */
  onDelete: PropTypes.func,
  /** 是否支持删除 */
  canDelete: PropTypes.bool,
  /** 修改内容回调 */
  onChange: PropTypes.func,
  /** 自定义class */
  className: PropTypes.string,
  /** 默认值 */
  defaultValue: PropTypes.string,
  /** 占位提示语 */
  placeholder: PropTypes.string
};
InputMatch.defaultProps = {
  visible: false,
  canDelete: false,
  placeholder: '每行输入一个值',
  typeOptions: [
    {
      label: '模糊匹配',
      value: 'fuzzy'
    },
    {
      label: '精确匹配',
      value: 'exact'
    }
  ],
  onChange: nfn,
  defaultValue: '全部',
  onDelete: nfn
};
